import { render, staticRenderFns } from "./AddDeviceEndpoint.vue?vue&type=template&id=cef121d8&scoped=true"
import script from "./AddDeviceEndpoint.vue?vue&type=script&lang=js"
export * from "./AddDeviceEndpoint.vue?vue&type=script&lang=js"
import style0 from "./AddDeviceEndpoint.vue?vue&type=style&index=0&id=cef121d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cef121d8",
  null
  
)

export default component.exports